import { UsersCard } from "@components/Cards";

export const Users = () => {
  return <UsersCard />;
};
